/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Upload({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M7.4 11a.6.6 0 1 0 1.2 0V3.449l1.976 1.975a.6.6 0 0 0 .848-.848l-2.999-3a.622.622 0 0 0-.194-.13.598.598 0 0 0-.656.13l-3 3a.6.6 0 1 0 .85.848L7.4 3.45V11Z" /><path fill="currentColor" d="M5.175 8.4H5.5a.6.6 0 0 1 0 1.2h-.3c-.57 0-.961 0-1.265.025-.296.024-.455.069-.57.128a1.4 1.4 0 0 0-.612.611c-.06.116-.104.275-.128.571-.025.304-.025.695-.025 1.265v.2c0 .29 0 .471.012.608.01.13.027.165.032.174a.4.4 0 0 0 .174.174.494.494 0 0 0 .174.032c.137.011.318.012.608.012h8.8c.29 0 .471 0 .608-.012a.494.494 0 0 0 .174-.032.4.4 0 0 0 .174-.174.494.494 0 0 0 .032-.174c.011-.137.012-.318.012-.608v-.2c0-.57 0-.961-.025-1.265-.024-.296-.069-.455-.128-.57a1.4 1.4 0 0 0-.611-.612c-.116-.06-.275-.104-.571-.128C11.76 9.6 11.37 9.6 10.8 9.6h-.3a.6.6 0 1 1 0-1.2h.325c.539 0 .98 0 1.338.03.37.03.705.094 1.017.253a2.6 2.6 0 0 1 1.137 1.137c.159.312.223.647.254 1.018.029.358.029.798.029 1.337v.247c0 .261 0 .492-.016.684a1.627 1.627 0 0 1-.158.62 1.6 1.6 0 0 1-.7.7 1.627 1.627 0 0 1-.62.158c-.192.016-.423.016-.684.016H3.578c-.261 0-.492 0-.684-.016a1.626 1.626 0 0 1-.62-.158 1.6 1.6 0 0 1-.7-.7 1.626 1.626 0 0 1-.158-.62c-.016-.192-.016-.423-.016-.684v-.247c0-.539 0-.98.03-1.338.03-.37.094-.705.253-1.017A2.6 2.6 0 0 1 2.82 8.683c.312-.159.647-.223 1.018-.254.358-.029.798-.029 1.337-.029Z" /></svg>;
}
;